import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { SUBSCRIBER_ROLE } from '../../config/roles.config';

const SubscriberRole = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  validOptions,
  sx,
  error,
}) => (
  <FormControl fullWidth error={error !== ''}>
    <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      sx={sx}
    >
      {validOptions.map((k) => (
        <MenuItem key={`${id}-v-${k}`} value={SUBSCRIBER_ROLE[k].value}>
          {SUBSCRIBER_ROLE[k].label}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

SubscriberRole.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  validOptions: PropTypes.string.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
SubscriberRole.defaultProps = {
  sx: {},
  error: '',
};

export default SubscriberRole;
